import { useEffect } from "react";
import { useIntercom } from "react-use-intercom";
import { useWindowSize } from 'react-use';

export function useToggleIntercom(show = true) {
  const { shutdown, boot } = useIntercom();
  const { width } = useWindowSize();

  useEffect(() => {
    if (width < 728) { // on smaller size we always disable intercom
      shutdown();
    } else {
      show ? boot() : shutdown()
    }
  }, [show, width]);
}

export default useToggleIntercom;
